
seedWebServices.service('IntegrationAdminService', ['$resource', '$routeParams', '$http', '$cacheFactory', function ($resource, $routeParams, $http, $cacheFactory) {
	//console.log('create service IntegrationAdminService');

	var serviceCache = $cacheFactory('IntegrationAdminService');

	var _srvData = {
		loadedItem: null,
		isLoaded: false,
		listItems: [],
		tab: null
	};

	var baseUrl = '../Api/IntegrationAdmin';
		
	var res = $resource(baseUrl + 'Api/:id', {}, {
		list: { method: 'GET', params: { stringFilter: 'stringFilter', tabFilter: 'tabFilter', sortField : 'sortField', skipNumber: 'skipNumber', takeNumber: 'takeNumber', groupFilter: 'groupFilter' }, isArray: true, cache: serviceCache }, //cache: serviceCache
		get: { method: 'GET', params: { id: 'id' }, isArray: false, cache: serviceCache }, //cache: serviceCache
		save: { method: 'POST', params: { id: 'id' }, isArray: false},
		put: { method: 'PUT', params: { data: 'data' }, isArray: false},
		'delete': {method: 'DELETE', params: {id: 'id'}, isArray: false},
		deleteBatch: {method: 'DELETE', params: {ids: 'ids'}, isArray: false},
		//deleteBatch: {method: 'GET', params: {ids: 'ids'}, isArray: true},
		execute : {method: 'GET', params: { id: 'id' }, isArray: true},
		action: { method: 'GET', params: { id: 'id', actionTag: 'actionTag' }, isArray: false },
		enabledOnly: { method: 'GET', params: { enabledOnly: 'true' }, isArray: true, cache: serviceCache },
		getList: { method: 'GET', params: { id: 'id', actionTag: 'actionTag' }, isArray: true }
	});

	// apiMethod = '/doSomething'
	res.getMethod = function (apiMethod, parameters, isCacheable, responseType, headers) {
		var cache = false;
		if (isCacheable) {
			cache = serviceCache;
		}

		var config = {
			params: parameters,
			cache: cache
		};

		if (responseType) {
			config.responseType = responseType;
		}

		if (headers) {
			config.headers = headers;
		}

		return $http.get(baseUrl + apiMethod, config);
	};

	res.postMethod = function (apiMethod, data, config) {
		return $http.post(baseUrl + apiMethod, data, config);
	};

	res.putMethod = function (apiMethod, data, config) {
		return $http.put(baseUrl + apiMethod, data, config);
	};

	res.getData = function () {
		return _srvData;
	};

	res.resetCache = function ()
	{
		_srvData.loadedItem = null;
		_srvData.tab = null;
		_srvData.listItems = null;
		serviceCache.removeAll();
	};

	var searchFilter = '';
	res.getSearchFilter = function ()
	{
		return searchFilter;
	};

	res.setSearchFilter = function (newSearchFilter)
	{
		searchFilter = newSearchFilter;
	};

	res.getGroupFilter = function () {
		if ($routeParams.group) {
			return $routeParams.group;
		}
		else {
			return '';
		}	    
	};

	var tabPages = [];
	res.getActualPage = function (tabID)
	{
		return tabPages[tabID];
	};

	res.setActualPage = function (tabID, newActualPage)
	{
		tabPages[tabID] = newActualPage;
	};

	var columnSearchFilter = [];
	res.getColumnSearchFilter = function (tabID)
	{
		if (!columnSearchFilter[tabID]) {
			columnSearchFilter[tabID] = [];
		}
		return columnSearchFilter[tabID];
	};

	res.setColumnSearchFilter = function (tabID, newSearchFilter)
	{
		columnSearchFilter[tabID] = newSearchFilter;
	};

	var tableSort = [];
	res.getTableSort = function (tabID)
	{
		return tableSort[tabID];
	};

	res.setTableSort = function (tabID, newSort)
	{
		tableSort[tabID] = newSort;
	};
	
	res.getTabTotals = function (filterTabs) {
		var tabs = [];
		for (var i in filterTabs) {
			var tab = filterTabs[i];
			tabs.push({tabID: tab.ID, tabName: tab.Name, tabOrder: tab.TabOrder, tabFilter: tab.Filter, tabCount: 0});
		}
		//console.log('filterTabs');
		//console.log(filterTabs);
		//console.log('Tabs');
		//console.log(tabs);

	    var params = {        
			tabs: tabs
	    };
	    return res.getMethod ('/GetTabTotals', params, true);
	};

	res.getInvitations = function (id) {
        return $http.get(baseUrl + '/GetInvitations', {
            params: { id: id },
            cache: false
        });
    };	

	 res.getColumnValues = function (colName, tabFilter) {
        var params = {
            colName: colName,
			tabFilter: tabFilter,
        };
        return res.getMethod('/GetColumnValues', params, true);
    };

	res.getIntegrationGroups = function () {
		return $http.get(baseUrl + '/GetIntegrationGroups', {
			params: {  },
			cache: serviceCache
		});
	};

	res.saveIntegrationGroup = function (group) {
		return $http.put(baseUrl + '/SaveIntegrationGroup', group);
	};

	return res;	
},

]);
